export enum PaymentState {
  None = 0,
  Successful = 1 << 0,
  RequiresAction = 1 << 1,
  Failed = 1 << 2,
}
